import InlineForm from "./inline-form";

export const schema = {
    date: {
        name: "Date",
        type: "date",
        placeholder: "Enter Date",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    licenseesName: {
        name: "Licensees Name",
        type: "text",
        placeholder: "Enter Licensees Name",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    licenseNumber: {
        name: "Individual LIC NO.",
        type: "text",
        placeholder: "Enter LIC NO.",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    placeOfBusinessBeingSupervised: {
        name: "Place Of Business Being Supervised",
        type: "text",
        placeholder: "Enter Place Of Business Being Supervised",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    trustAccountBeingSupervised: {
        name: "Trust Account Being Supervised",
        type: "text",
        placeholder: "Enter Trust Account Being Supervised",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    dateOfAdvisingOFT: {
        name: "Date of Advising OFT",
        type: "date",
        placeholder: "Enter Date of Advising OFT",
        style: {
            minWidth: "20ch",
        },
        searchable: true,
    },
    evidenceOfOFTAttachedFile: {
        name: "Evidence of OFT",
        type: "file",
        placeholder: "Enter Date of Advising OFT",
        style: {
            minWidth: "30ch",
        },
        searchable: true,
    },
};

const SG1FairTradingNotificationForm = ({ formType, formTitle }) => {
    return <InlineForm schema={schema} formTitle={formTitle} formType={formType} />;
};

export default SG1FairTradingNotificationForm;
